module.exports = __webpack_public_path__ + "img/loading.56c9f4de.svg";